export default __webpack_public_path__ + "media/zurb/img/legacy/chop/1-7ed73c29336616785d663c906be2ff9a.png";